import { render, staticRenderFns } from "./ActivateUserQR.vue?vue&type=template&id=b40d0ff2&"
import script from "./ActivateUserQR.vue?vue&type=script&lang=js&"
export * from "./ActivateUserQR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports